import { CMSBlock } from "./CMSBlock";

export const ONE_COLUMN_12 = "1 Column (12)";
export const TWO_COLUMNS_6_6 = "2 Columns (6-6)";
export const TWO_COLUMNS_4_8 = "2 Columns (4-8)";
export const TWO_COLUMNS_8_4 = "2 Columns (8-4)";
export const TWO_COLUMNS_3_9 = "2 Columns (3-9)";
export const TWO_COLUMNS_9_3 = "2 Columns (9-3)";
export const THREE_COLUMNS_4_4_4 = "3 Columns (4-4-4)";
export const THREE_COLUMNS_3_6_3 = "3 Columns (3-6-3)";
export const THREE_COLUMNS_3_3_6 = "3 Columns (3-3-6)";
export const THREE_COLUMNS_6_3_3 = "3 Columns (6-3-3)";
export const THREE_COLUMNS_2_4_6 = "3 Columns (2-4-6)";
export const THREE_COLUMNS_2_6_4 = "3 Columns (2-6-4)";
export const THREE_COLUMNS_4_2_6 = "3 Columns (4-2-6)";
export const THREE_COLUMNS_4_6_2 = "3 Columns (4-6-2)";
export const THREE_COLUMNS_6_2_4 = "3 Columns (6-2-4)";
export const THREE_COLUMNS_6_4_2 = "3 Columns (6-4-2)";
export const FOUR_COLUMNS_3_3_3_3 = "4 Columns (3-3-3-3)";
export const FOUR_COLUMNS_6_2_2_2 = "4 Columns (6-2-2-2)";
export const FOUR_COLUMNS_2_6_2_2 = "4 Columns (2-6-2-2)";
export const FOUR_COLUMNS_2_2_6_2 = "4 Columns (2-2-6-2)";
export const FOUR_COLUMNS_2_2_2_6 = "4 Columns (2-2-2-6)";
export const FOUR_COLUMNS_2_2_4_4 = "4 Columns (2-2-4-4)";
export const FOUR_COLUMNS_2_4_4_2 = "4 Columns (2-4-4-2)";
export const FOUR_COLUMNS_2_4_2_4 = "4 Columns (2-4-2-4)";
export const FOUR_COLUMNS_4_2_4_2 = "4 Columns (4-2-4-2)";
export const FOUR_COLUMNS_4_4_2_2 = "4 Columns (4-4-2-2)";
export const FOUR_COLUMNS_4_2_2_4 = "4 Columns (4-2-2-4)";
export const SIX_COLUMNS_2_2_2_2_2_2 = "6 Columns (2-2-2-2-2-2)";

export type CMSColumnContentAlignment = "Top" | "Bottom" | "Spread" | "Center";
export type CMSColumnHorizontalAlign = "Start" | "Center" | "End";
export type CMSColumnVerticalAlign = "Top" | "Middle" | "Bottom";

export interface CMSRowProps {
    layout: string;
    columns: {
        column: {
            content: CMSBlock[];
            align_content: CMSColumnContentAlignment;
            horizontal_align: CMSColumnHorizontalAlign;
            vertical_align: CMSColumnVerticalAlign;
        };
    }[];
}
